import * as Sentry from '@sentry/vue';
import { Router } from 'vue-router';

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';

export function initSentry(app: any, router: Router): void {
  Sentry.init({
    app,
    environment: import.meta.env.VITE_ENV || '',
    dsn: SENTRY_DSN,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      // Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: ['localhost', import.meta.env.VITE_API_URL],
    // Session Replay
    // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Profiling
    // profilesSampleRate: 1.0, // Profile 100% of the transactions. This value is relative to tracesSampleRate
  });

  app.config.errorHandler = (err, vm, info) => {
    Sentry.captureException(err);
    console.error(err, info);
  };
}
